import { Promise } from 'es6-promise'
import commonRequest from 'Api/index'
import {
    isCookieEnabled,
    setCookie,
    removeCookie
} from 'tiny-cookie'

// state
const state = {
    currentUser: null,
    login: {},
}

// getters
const getters = {
    GET_CURRENT_ACCOUNT: state => {
        return state.login
    },
}

// actions
const actions = {
    SET_USER_DATA: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                'api/v1/0/auth/userinfo/',
                payload,
                function (res) {
                    context.commit('SET_USER_DATA_HANDLER', res.data)
                    if (isCookieEnabled()) {
                        setCookie('role', res.data.response.group_id)
                        resolve(res)
                    } else {
                        reject(res)
                    }
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    LOGIN: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                'api/v1/auth/jwt-auth/',
                payload,
                function (res) {
                    if (isCookieEnabled()) {
                        setCookie('token', res.data.response.token)
                    }
                    context.commit('LOGIN_USER_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    if (isCookieEnabled()) {
                        removeCookie('token')
                    }
                    reject(error)
                }
            )
        })
    },
    LOGOUT: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                'api/v1/auth/jwt-refresh/',
                {
                    token: payload
                },
                function (res) {
                    context.commit('LOGOUT', res.data)
                    if (isCookieEnabled()) {
                        removeCookie('token')
                        resolve(res)
                    } else {
                        let error = ''
                        reject(error)
                    }
                },
                function (error) {
                    if (isCookieEnabled()) {
                        removeCookie('token')
                    }
                    reject(error)
                }
            )
        })
    },
    REGISTER_ACCOUNT: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/auth/signup/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    UPDATE_CURRENT_USER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.putRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/user/update/${payload.id}/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    SEND_EMAIL_FORGOT_PASSWORD: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/forgot_password/send_email_reset_password/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    CONFIRM_RESET_PASSWORD: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/auth/confirm-reset-password/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    CHANGE_PASSWORD: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/user/change_password/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    ACTIVATE_ACCOUNT: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/accounts/activated/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    SOCIAL_NETWORK_LOGIN: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/social_network/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    GET_SOCIAL_NETWORK: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/social_network/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    LOGIN_WITH_GOOGLE: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/social_network_login/login_with_google/`,
                payload,
                function (res) {
                    if (res.data.response !== undefined) {
                        if (isCookieEnabled()) {
                            setCookie('token', res.data.response.token)
                        }
                        context.commit('LOGIN_USER_HANDLER', res.data)
                    }
                    resolve(res)
                },
                function (error) {
                    if (isCookieEnabled()) {
                        removeCookie('token')
                    }
                    reject(error)
                }
            )
        })
    },
    REGISTER_WITH_GOOGLE: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_MAN_URL,
                `api/v1/social_network_login/register_with_google/`,
                payload,
                function (res) {
                    if (isCookieEnabled()) {
                        setCookie('token', res.data.response.token)
                    }
                    context.commit('LOGIN_USER_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    if (isCookieEnabled()) {
                        removeCookie('token')
                    }
                    reject(error)
                }
            )
        })
    }
}

// mutations
const mutations = {
    LOGIN_USER_HANDLER: (state, payload) => {
        state.currentUser = payload
    },
    SET_USER_DATA_HANDLER: (state, payload) => {
        let userData = {
            id: '',
            username: '',
            firstname: '',
            lastname: '',
            email: '',
            lastlogin: '',
            group_id: '',
            group_name: '',
            url_avatar: '',
            permissions: '',
            actions: '',
            phone: '',
            gender: '',
            birth_date: '',
            longitude: null,
            latitude: null,
            province: null,
            district: null,
            ward: null,
            street: null,
            sys_role: null,
            entity_roles: []
        }
        userData.id = payload.response && payload.response.id
        userData.username = payload.response && payload.response.username
        userData.firstname = payload.response && payload.response.firstname
        userData.lastname = payload.response && payload.response.lastname
        userData.email = payload.response && payload.response.email
        userData.lastlogin = payload.response && payload.response.last_login
        userData.group_id = payload.response && payload.response.group_id
        userData.group_name = payload.response && payload.response.group_name
        userData.url_avatar = payload.response && payload.response.url_avatar
        userData.permissions = payload.response && payload.response.permissions
        userData.phone = payload.response && payload.response.phone
        userData.gender = payload.response && payload.response.gender
        userData.actions = payload.response && payload.response.actions
        userData.birth_date = payload.response && payload.response.birth_date
        userData.sys_role = payload.response && payload.response.sys_role
        userData.entity_roles = payload.response && payload.response.entity_roles
        userData.longitude = payload.response && payload.response.longitude
        userData.latitude = payload.response && payload.response.latitude
        userData.province = payload.response && payload.response.province
        userData.district = payload.response && payload.response.district
        userData.ward = payload.response && payload.response.ward
        userData.street = payload.response && payload.response.street
        // Set state for getter
        state.login = userData
    },
    LOGOUT: (state) => {
        state.login = {
            id: '',
            username: '',
            firstname: '',
            lastname: '',
            email: '',
            lastlogin: '',
            group_id: '',
            group_name: '',
            url_avatar: '',
            permissions: [],
            actions: [],
            phone: '',
            gender: '',
            birth_date: '',
            longitude: null,
            latitude: null,
            province: null,
            district: null,
            ward: null,
            street: null,
            sys_role: null,
            entity_roles: []
        }
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}